import { render } from "./Speakers.vue?vue&type=template&id=6bcf1018&ts=true"
import script from "./Speakers.vue?vue&type=script&lang=ts"
export * from "./Speakers.vue?vue&type=script&lang=ts"

import "./Speakers.vue?vue&type=style&index=0&id=6bcf1018&lang=scss"

import exportComponent from "D:\\封面新闻\\activity\\ssccloudtour\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__